export const colorList = [
    {id: 1, base: '#888aaf', light: '#9b9cbc', dark: '#686a9a'},
    {id: 2, base: '#aad7ff', light: '#d9edff', dark: '#5ab1ff'},
    {id: 3, base: '#ffbfa9', light: '#ffe2d8', dark: '#ff8259'},
    {id: 4, base: '#8ecf6f', light: '#a1d787', dark: '#6dc245'},
    {id: 5, base: '#e87a95', light: '#ed98ad', dark: '#df466b'},
    {id: 6, base: '#ffc021', light: '#ffc83e', dark: '#eeab00'}
]